export default "__VITE_ASSET__CBQ4kVz$__"